<!-- 客户列表 -->
<template>
    <div class="content">
        <div class="header">
            <div class="text">档期指引</div>
        </div>
        <!-- 搜索部分 -->
        <div class="search-box">
            <veui-form :data="formData" @submit="handleFormSubmit(1)">
                <veui-field label="城市" class="city">
                    <citySelect
                        class="city-option"
                        :city="formData.city"
                        type="2"
                        @cityChange="cityChange"
                    />
                </veui-field>
                <veui-field
                    name="areaSelected"
                    label="选择领域"
                    class="type l"
                >
                    <veui-select
                        v-model="formData.domain"
                        data-stat-ignore
                        clearable
                        multiple
                        searchable
                        placeholder="请选择领域"
                        class="option"
                    >
                        <veui-option-group
                            v-for="(item, index) in doaminOption"
                            :key="index"
                            :label="item.name"
                            position="popup"
                        >
                            <veui-option
                                v-for="item in item.children"
                                :key="item.id"
                                :value="item.id"
                                :label="item.name"
                            />
                        </veui-option-group>
                    </veui-select>
                </veui-field>
                <veui-field label="流量热度" class="type l">
                    <veui-select
                        v-model="formData.heat"
                        class="option-heat"
                        placeholder="请选择热度"
                        :options="heatTypeOptions"
                        clearable
                        multiple
                    />
                </veui-field>
                <template #actions>
                    <veui-button
                        ui="strong" @click="resetForm"
                    >重置</veui-button>
                    <veui-button ui="primary" type="submit">查询</veui-button>
                </template>
            </veui-form>
        </div>
        <!-- 表格数据 -->
        <div class="table-box">
            <div class="transfer-once-box"></div>
            <!-- <div
                class="transfer-once"
                @click="exportSheet('schedul')"
            ><div class="export-icon"></div>导出档期表</div> -->
            <veui-table
                :data="tableData"
                :scroll="{x: 1048}"
                role="columnheader"
                :loading="isLoading"
            >
                <veui-table-column
                    field="city_name"
                    title="城市"
                    width="120"
                    fixed="left"
                >
                    <template #default="{city_name}">
                        <div class="table-name">{{ city_name }}</div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="domain_name"
                    title="领域"
                    width="120"
                    fixed="left"
                >
                    <template #default="{domain_name}">
                        <div class="table-name">{{ domain_name }}</div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="hot_level"
                    title="流量热度"
                    width="120"
                    fixed="left"
                >
                    <template #default="{hot_level}">
                        <div v-if="hot_level === 3" class="heat-high">高</div>
                        <div v-else-if="hot_level === 2" class="heat-middle">中</div>
                        <div v-else class="heat-low">低</div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="list"
                    title="档期忙闲"
                    width="820"
                >
                    <template #default="{list, index: lineNum, domain_name}">
                        <div class="schedul-box">
                            <div
                                v-for="item,schedulNum in list"
                                :key="item.value"
                                class="schedul-box-item"
                                :class="item.is_available === '1' ? '' : 'schedul-box-item-not'"
                                @click="schedulClick(lineNum, schedulNum, item, domain_name)"
                            >
                                <div v-if="item.isAcross" class="schedul-box-item-across">
                                    <div class="schedul-box-item-time">{{ item.labelStart[0] }}月{{ item.labelStart[1] }}</div>
                                    -
                                    <div class="schedul-box-item-time">{{ item.labelEnd[0] }}月{{ item.labelEnd[1] }}</div>
                                </div>
                                <div v-else class="schedul-box-item-notacross">
                                    <div class="schedul-box-item-time">{{ item.labelStart[0] }}月</div>
                                    <div class="schedul-box-item-time">{{ item.labelStart[1] }}-{{ item.labelEnd[1] }}</div>
                                </div>
                                <div v-if="item.selected" class="schedul-select">
                                    <img src="https://lvlin-base.cdn.bcebos.com/fe-saas/common/schadul-select-right.png">
                                </div>
                            </div>
                        </div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="operation"
                    title="操作"
                    width="112"
                    align="center"
                    fixed="right"
                    :span="operationSpan"
                >
                    <template>
                        <veui-button
                            ui="text"
                            @click="getLawyerTableData(1)"
                        >
                            匹配
                        </veui-button>
                        <veui-button
                            ui="text"
                            @click="clearSchedulSelected"
                        >
                            清除
                        </veui-button>
                    </template>
                </veui-table-column>
            </veui-table>
            <!-- 分页 -->
            <veui-pagination
                v-if="tableData && tableData.length"
                :page="brandExposurePageNum.pn"
                :page-size="brandExposurePageNum.rn"
                :total="brandExposurePageNum.total"
                class="pagination"
                @redirect="pageChange"
            />
        </div>
        <div class="line"></div>
        <div class="header">
            <div class="text">客户排期<span class="sub-title">注：仅展示尊享和精英会员</span></div>
            <!-- <div
                class="transfer-once-lawyer"
                @click="exportSheet('lawyer')"
            ><div class="export-icon"></div>导出客户排期表</div> -->
        </div>

        <div class="table-box">
            <div class="transfer-once-box"></div>
            <veui-table
                :data="lawyerTableData"
                :scroll="{x: 1048}"
                role="columnheader"
                :loading="isLawyerLoading"
            >
                <veui-table-column
                    field="name"
                    title="客户名"
                    width="120"
                >
                    <template #default="{name}">
                        <div class="table-name">{{ name }}</div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="phone"
                    title="手机号"
                    width="150"
                >
                    <template #default="{phone}">
                        <div class="table-name">{{ phone }}</div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="cityName"
                    title="城市"
                    width="120"
                >
                    <template #default="{cityName}">
                        <div class="table-name">{{ cityName }}</div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="area"
                    title="擅长领域"
                    width="300"
                >
                    <template #default="{area}">
                        <div class="area-box">
                            <div
                                v-for="item in area"
                                :key="item.value"
                                class="area-box-item"
                                :class="item.hasArea ? '' : 'area-box-item-not'"
                            >
                                <span>{{ item.value }}</span>
                            </div>
                        </div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="is_valid"
                    title="目标档期内客户状态"
                    width="180"
                >
                    <template #head>
                        <div class="title-head">
                            目标档期内客户状态
                            <img
                                ref="is_valid"
                                class="tooltip-icon"
                                src="../../../assets/img/law/question.svg"
                            />
                            <veui-tooltip target="is_valid">
                                当前用户在上方档期表所选择的档期内是否购买了C位律师
                            </veui-tooltip>
                        </div>
                    </template>
                    <template #default="{is_valid}">
                        <div class="table-name">{{ is_valid ? '空闲中' : '已购买' }}</div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="cpt_order_count"
                    title="累计购买单数"
                    width="140"
                >
                    <template #head>
                        <div class="title-head">
                            累计购买单数
                            <img
                                ref="cpt_order_count"
                                class="tooltip-icon"
                                src="../../../assets/img/law/question.svg"
                            />
                            <veui-tooltip target="cpt_order_count">
                                当前用户购买过的C位律师订单总数
                            </veui-tooltip>
                        </div>
                    </template>
                    <template #default="{cpt_order_count}">
                        <div class="table-name">{{ cpt_order_count }}</div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    v-if="userType === 1"
                    field="firm_subaccount_name"
                    title="销售人员"
                    width="120"
                >
                    <template #default="{firm_subaccount_name}">
                        <div class="table-name">{{ firm_subaccount_name || '-' }}</div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="operation"
                    title="操作"
                    width="112"
                    align="center"
                    fixed="right"
                >
                    <template #default="{license}">
                        <veui-button
                            ui="text"
                            @click="showLawyerDetail(license)"
                        >
                            详情
                        </veui-button>
                    </template>
                </veui-table-column>
            </veui-table>
        </div>
        <!-- 分页 -->
        <veui-pagination
            v-if="tableData && tableData.length"
            :page="customErexposurePageNum.pn"
            :page-size="customErexposurePageNum.rn"
            :total="customErexposurePageNum.total"
            class="pagination"
            @redirect="lawyerPageChange"
        />
        <div class="pagination-bot"></div>
        <customerDetail
            v-if="openDetailDrawer"
            :open="openDetailDrawer"
            :fid="fid"
            :cur-lawyer="curLawyer"
            @closeDrawer="closeDetailDrawer"
        />
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 客户列表
 * @author dingzhenyue
 */
import {
    Select,
    Form,
    Field,
    Button,
    Table,
    OptionGroup,
    Option,
    Column,
    Pagination,
    Tooltip
} from 'veui';
import {mapState} from 'vuex';
import citySelect from '@/components/citySelect.vue';
import customerDetail from '../components/customer-detail.vue';
import {downloadFile} from '@/utils/download';

const url = {
    domain: '/bp/api/lawyer/get_lawyer_domain',
    brandexposurelist: '/bp/api/product/brandexposurelist',
    customerexposurelist: '/bp/crm/customerexposurelist',
    getcustomer: '/bp/crm/getcustomer'
};

export default {
    name: 'schedul-guide',
    components: {
        'veui-select': Select,
        'veui-form': Form,
        'veui-field': Field,
        'veui-button': Button,
        'veui-option-group': OptionGroup,
        'veui-option': Option,
        'veui-table': Table,
        'veui-table-column': Column,
        'veui-pagination': Pagination,
        'veui-tooltip': Tooltip,
        citySelect,
        customerDetail
    },
    data() {
        return {
            // 热度map
            heatTypeOptions: [
                {
                    label: '高',
                    value: 3
                },
                {
                    label: '中',
                    value: 2
                }
            ],
            // 搜索表单数据存储，默认北京
            formData: {
                city: [110000, 110100]
            },
            // 档期筛选数据
            tableData: [],
            // 档期筛选原数据，未处理之前的数据
            tableOriData: [],
            // 档期筛选律师数据
            lawyerTableData: [],
            // 档期勾选数据
            schedulSelecetd: [],
            isLoading: false,
            isLawyerLoading: false,
            // 领域数据
            doaminOption: [],
            pn: 1,
            rn: 10,
            count: 20,
            // 打开当前选中律师详情
            openDetailDrawer: false,
            // 当前选中律师
            curLawyer: null,
            // 当前选中代理id
            fid: '',
            brandExposurePageNum: {
                pn: 0,
                rn: 5,
                total: 0
            },
            customErexposurePageNum: {
                pn: 0,
                rn: 5,
                total: 0
            }
        };
    },
    computed: {
        ...mapState({
            userInfoNew: state => state.lawStore.userInfoNew,
            userType: state => state.Menu.userType
        })
    },
    watch: {
        userInfoNew: {
            deep: true,
            immediate: true,
            handler(newVal) {
                // 机构主账号
                if (newVal && newVal.law_firm_info) {
                    this.fid = newVal.law_firm_info?.id || '';
                }
                // 机构子账号
                else if (newVal && newVal.law_firm_subaccount) {
                    this.fid = newVal.law_firm_subaccount?.fid || '';
                }
                if (!this.fid) {
                    return;
                }
            }
        }
    },
    created() {
        this.$wywLog.addKey({
            fr: this.$route.query.from || this.$route.query.fr || ''
        });
        // 页面PV打点
        this.$wywLog.send({
            area: 'all_show',
            action: 'show',
            page: 'schedule_guide',
            serverId: 18470
        });
        // 动态获取领域数据
        this.getDomain();
        // 初始化档期数据
        this.handleFormSubmit(1);
    },
    methods: {

        /**
         * 导出表格
         *
         * @param {string} type 类型
         */

        exportSheet(type) {
            if (type === 'lawyer') {
                if (!this.lawyerTableData || !this.lawyerTableData.length) {
                    return;
                }
                const schedulSelecetd = this.schedulSelecetd;
                let domain = [];
                schedulSelecetd.map(item => {
                    domain.push(item.tableItem.domain);
                    return item;
                });
                const {city} = this.formData;
                const params = {
                    fid: this.fid,
                    pn: this.customErexposurePageNum.pn,
                    rn: this.customErexposurePageNum.rn,
                    domain: domain && domain.join(',') || '',
                    value: this.schedulSelecetd[0] && this.schedulSelecetd[0].item.value,
                    city: city[1]
                };
                const urlParams = new URLSearchParams(params).toString();
                downloadFile(
                    `/bp/crm/download/customerexposurelist?${urlParams}`
                );
            }
            else {
                const {city, domain, heat} = this.formData;
                let params = {
                    city_code: city[1],
                    domain: domain && domain.join(',') || '',
                    hot_level: heat && heat.join(',') || '',
                    pn: this.brandExposurePageNum.pn,
                    rn: this.brandExposurePageNum.rn
                };
                const urlParams = new URLSearchParams(params).toString();
                downloadFile(
                    `/bp/api/product/download/brandexposurelist?${urlParams}`
                );
            }
            this.$toast.success('数据导出成功');
        },

        /**
         * 翻页时更新数据
         *
         * @param {number} pn 第几页
         */

        pageChange(pn) {
            this.handleFormSubmit(pn, true);
        },

        lawyerPageChange(pn) {
            this.getLawyerTableData(pn);
        },

        /**
         * 档期数据请求
         */

        handleFormSubmit(pn, isPageChange) {
            if (this.isLoading) {
                return;
            }
            const {city, domain, heat} = this.formData;
            if (domain && domain .length && domain.length < 3) {
                this.$toast.error('请选择三个及以上领域');
                return;
            }
            this.isLoading = true;
            let params = {
                city_code: city[1],
                domain: domain && domain.join(',') || '',
                hot_level: heat && heat.join(',') || '3,2',
                pn: pn ? pn : this.brandExposurePageNum.pn + 1,
                rn: this.brandExposurePageNum.rn
            };
            this.$http
                .get(url.brandexposurelist, {
                    params
                })
                .then(res => {
                    this.isLoading = false;
                    const data = this.$normalizeResponseData(res);
                    if (!data || !data.data) {
                        this.tableData = [];
                        this.schedulSelecetd = [];
                        this.tableOriData = [];
                        this.lawyerTableData = [];
                        return;
                    }
                    let list = data.data;
                    list = list.map(item => {
                        item.list.map(item2 => {
                            if (!item2 || !item2.label) {
                                return item2;
                            }
                            const times = item2.label.split('-');
                            item2.labelStart = [times[0].split('.')[0].replace(/^0+/, '')];
                            item2.labelStart[1] = times[0].split('.')[1];
                            item2.labelEnd = [times[1].split('.')[0].replace(/^0+/, '')];
                            item2.labelEnd[1] = times[1].split('.')[1];
                            if (item2.labelStart[0] !== item2.labelEnd[0]) {
                                item2.isAcross = true;
                            }
                            return item2;
                        });
                        return item;
                    });
                    this.brandExposurePageNum = {
                        pn: data.pn,
                        rn: data.rn,
                        total: data.total
                    };
                    if (!isPageChange) {
                        this.schedulSelecetd = [];
                        this.tableData = list;
                        this.tableOriData = JSON.parse(JSON.stringify(data.data));
                        this.lawyerTableData = [];
                        return;
                    }
                    let schedulSelecetd = this.schedulSelecetd.filter(item => {
                        return item.pn === data.pn;
                    });
                    schedulSelecetd.map(item => {
                        list[item.lineNum].list[item.index].selected = true;
                        return item;
                    });
                    this.tableData = list;
                    this.tableOriData = JSON.parse(JSON.stringify(data.data));
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                    this.isLoading = false;
                });
        },

        /**
         * 重置
         */

        resetForm() {
            this.formData = {
                heat: [],
                domain: [],
                city: [110000, 110100]
            };
            this.handleFormSubmit(1);
        },

        /**
         * 展示律师详情
         */

        showLawyerDetail(license) {
            this.$wywLog.send({
                area: 'allinfo_btn',
                action: 'click',
                page: 'schedule_guide',
                serverId: 18470
            });
            this.curLawyer = {
                license
            };
            this.openDetailDrawer = true;
        },

        /**
         * 城市筛选过改变时
         */

        cityChange(data = {}) {
            let {value} = data;
            this.formData.city = value;
        },

        /**
         * 档期点击选中取消处理
         */

        schedulClick(lineNum, schedulNum, item, domainName) {
            // 档期不可用时直接返回
            if (item && +item.is_available !== 1) {
                return;
            }
            // 切换当前档期的选中状态
            const tableData = this.tableData;
            const schedulItem = tableData[lineNum].list[schedulNum];
            schedulItem.selected = !schedulItem.selected;
            this.tableData = [...tableData];
            // 档期选中处理，将当前档期添加到选中数组中
            const pn = this.brandExposurePageNum.pn;
            if (schedulItem.selected) {
                this.schedulSelecetd.push({
                    line: pn + '-' + lineNum, // 用于区分不同页面的档期
                    lineNum: lineNum, // 当前行索引
                    index: schedulNum, // 当前档期的索引
                    item, // 当前选中档期的数据
                    tableItem: tableData[lineNum], // 当前选中的行数据
                    pn // 当前选中的页数
                });
                return;
            }
            // 取消选中时，从选中数组中移除
            let delIndex = -1;
            for (let i = 0; i < this.schedulSelecetd.length; i++) {
                if (this.schedulSelecetd[i].pn === pn && this.schedulSelecetd[i].item.label === item.label && domainName === this.schedulSelecetd[i].tableItem.domain_name) {
                    delIndex = i;
                }
            }
            if (delIndex >= 0) {
                this.schedulSelecetd.splice(delIndex, 1);
            }
        },

        /**
         * 档期清除处理
         */

        clearSchedulSelected() {
            this.tableData = JSON.parse(JSON.stringify(this.tableOriData));
            this.lawyerTableData = [];
            this.schedulSelecetd = [];
        },

        /**
         * 动态获取领域数据
         */

        getDomain() {
            this.$http.get(url.domain, {
            }).then(res => {
                res = this.$normalizeResponseData(res);
                if (res) {
                    let data =  res;
                    this.doaminOption = data;
                }
            });
        },

        /**
         * 合并单元格
         */

        operationSpan(i) {
            if (i === 0) {
                return {row: 110};
            }
            return {row: 0};
        },

        /**
         * 关闭律师详情
         */

        closeDetailDrawer() {
            this.openDetailDrawer = !this.openDetailDrawer;
        },

        /**
         * 匹配处理
         */

        getLawyerTableData(pn) {
            this.$wywLog.send({
                area: 'match_btn',
                action: 'click',
                page: 'schedule_guide',
                serverId: 18470
            });
            // 校验数据记录
            let checkData = {
                line: [],
                index: []
            };
            const schedulSelecetd = this.schedulSelecetd;
            for (let i = 0; i < schedulSelecetd.length; i++) {
                if (checkData.line.indexOf(schedulSelecetd[i].line) === -1) {
                    checkData.line.push(schedulSelecetd[i].line);
                }
                if (checkData.index.indexOf(schedulSelecetd[i].index) === -1) {
                    checkData.index.push(schedulSelecetd[i].index);
                }
            }
            if (checkData.line.length < 3 && checkData.index.length !== 1) {
                this.$toast.error('请选择三个及以上领域并且同一时间段的档期');
                return;
            }
            if (checkData.line.length < 3) {
                this.$toast.error('请选择三个及以上领域');
                return;
            }
            if (checkData.index.length !== 1) {
                this.$toast.error('请选择同一时间段的档期');
                return;
            }
            let domain = [];
            let domainValue = [];
            schedulSelecetd.map(item => {
                domain.push(item.tableItem.domain);
                domainValue.push(item.tableItem.domain_name);
                return item;
            });
            this.isLawyerLoading = true;
            const {city} = this.formData;
            const params = {
                fid: this.fid,
                pn: pn ? pn : this.customErexposurePageNum.pn + 1,
                rn: this.customErexposurePageNum.rn,
                domain: domain && domain.join(',') || '',
                value: this.schedulSelecetd[0] && this.schedulSelecetd[0].item.value,
                city: city[1]
            };
            this.$http
                .get(url.customerexposurelist, {
                    params
                })
                .then(res => {
                    this.isLawyerLoading = false;
                    const data = this.$normalizeResponseData(res);
                    if (!data || !data.list) {
                        this.lawyerTableData = [];
                        return;
                    }
                    this.customErexposurePageNum = {
                        pn: data.pn,
                        rn: data.rn,
                        total: data.count
                    };
                    let lawyerTableData = data.list;
                    for (let i = 0; i < lawyerTableData.length; i++) {
                        lawyerTableData[i].area = lawyerTableData[i].domain.split('$');
                        for (let j = 0; j < lawyerTableData[i].area.length; j++) {
                            lawyerTableData[i].area[j] = {
                                value: lawyerTableData[i].area[j],
                                hasArea: false
                            };
                            if (domainValue.indexOf(lawyerTableData[i].area[j].value) >= 0) {
                                lawyerTableData[i].area[j].hasArea = true;
                            }
                        }
                    }
                    this.lawyerTableData = lawyerTableData;
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                    this.isLawyerLoading = false;
                });
        }
    }
};
</script>

<style lang='stylus' scoped>
@import "../../../assets/css/law-table.styl";

$$inputwidth= 220px
.content {
    background: #fff;
    box-shadow: 0 6px 14px 0 rgba(227, 233, 237, .35);
    border-radius: 8px;
    padding: 32px 30px 24px;

    .header {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        position: relative;

        .text {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #000;
            line-height: 18px;
        }

        .sub-title {
            font-family: PingFang SC;
            font-size: 12px;
            font-weight: 400;
            line-height: 18px;
            margin-left: 8px;
            color: #848691;
            vertical-align: top;
        }
    }

    .search-box {
        .veui-form {
            display: flex;
            flex-wrap: wrap;
            position: relative;
        }

        .name {
            margin-right: 36px;
        }

        /deep/ .veui-field-content {
            align-items: flex-start;
        }

        /deep/.veui-field {
            margin-bottom: 18px;
            min-height: 40px;

            .veui-field-label {
                height: 40px;
                margin-right: 0;
                width: 28px;
                text-align: left;
                line-height: 40px;
            }

            &.name,
            &.city,
            &.member-name {
                .veui-field-label {
                    justify-content: flex-start;
                }
            }

            &.l .veui-field-label {
                width: 85px;
            }

            &.m .veui-field-label {
                width: 58px;
            }

            &.member-name .veui-input.veui-focus {
                box-shadow: none;
            }
        }

        /deep/.veui-form-actions {
            margin-top: 0;
            padding-left: 0;

            .veui-button {
                margin-left: 0;

                &:last-child {
                    margin-left: 10px;
                }
            }
        }

        .veui-input {
            width: $inputWidth;
            height: 40px;
            margin-left: 20px;
            border: 1px solid #e9ecf3;
            border-radius: 8px;

            &.veui-focus,
            &:hover {
                border: 1px solid #3855d5;
                box-shadow: none;
            }
        }

        .veui-select.veui-select-expanded {
            border: 1px solid #3855d5;
        }

        /deep/.option {
            width: 275px;
            min-height: 40px;
            margin-left: 20px;
            border: 1px solid #e9ecf3;
            border-radius: 8px;

            .veui-input {
                border: none;
            }

            &:focus,
            &:hover,
            &.veui-select-expanded {
                border: 1px solid #3855d5;
            }
        }

        /deep/.option-heat {
            width: 120px;
            min-height: 40px;
            margin-left: 20px;
            border: 1px solid #e9ecf3;
            border-radius: 8px;
            margin-right: 20px;

            .veui-input {
                border: none;
            }

            &:focus,
            &:hover,
            &.veui-select-expanded {
                border: 1px solid #3855d5;
            }
        }

        .city-option {
            margin-left: 20px;
            width: 150px;
        }
    }

    .table-box {
        position: relative;
        margin-top: 16px;

        .transfer-once {
            position: absolute;
            height: 48px;
            right: 136px;
            top: 0;
            cursor: pointer;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #05f;
            line-height: 48px;
            font-weight: 400;
            display: flex;
            z-index 22
            align-items: center;

            .export-icon {
                margin-right: 4px;
                width: 20px;
                height: 20px;
                background: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/offline-qa/export.png) no-repeat center center / 100% 100%;
            }
        }

        /deep/.veui-table-bordered .veui-table-cell-sticky-left::after {
            width: 0;
        }
        /deep/.veui-table-has-bordered-body [role="cell"]:not(.veui-table-cell-first) {
            border-left-style: none;
        }
        /deep/.veui-table-has-bordered-header [role="columnheader"]:not(.veui-table-cell-first) {
            border-left-style: none;
        }

        /deep/.veui-table [role="cell"] {
            padding: 0 10px;
            height: 54px;
        }

        /deep/.veui-table [role="columnheader"] {
            padding: 19px 10px;
        }

        /deep/.veui-table-main {
            overflow-x: scroll;
            overflow-y: hidden;
        }

        .tip {
            cursor: pointer;
            font-family: PingFangSC-Regular;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            display: flex;

            img {
                height: 12px;
                width: 12px;
            }

            .text {
                font-size: 12px;
                color: #333;
                line-height: 14px;
                margin-left: 4px;
            }

            &.tab {
                right: 100px;
                top: 25px;
                width: 50px;
            }
        }

        /deep/.veui-table {
            .veui-table-cell-last {
                .veui-table-cell-content {
                    text-align: center;
                }
            }

            .veui-table-cell-content {
                position: relative;
                width: 100%;

                .status-dropdown,
                .ci-status {
                    padding-left: 12px;
                }

                .table-name {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .veui-button {
                    width: auto;
                    font-family: PingFangSC-Regular;
                    font-size: 16px;
                    color: #05f;
                    line-height: 16px;
                    font-weight: 400;
                }
            }
        }
    }

    .heat-high {
        width: 26px;
        height: 26px;
        border-radius: 2px;
        box-sizing: border-box;
        background: #fef0f0;
        border: 1px solid #fac7c7;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ed4343;
        font-size: 14px;
    }

    .heat-middle {
        width: 26px;
        height: 26px;
        border-radius: 2px;
        box-sizing: border-box;
        background: #fff7ee;
        border: 1px solid #fedebf;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fa9128;
        font-size: 14px;
    }

    .heat-low {
        width: 26px;
        height: 26px;
        border-radius: 2px;
        box-sizing: border-box;
        background: #eefaee;
        border: 1px solid #bee1ce;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #259c5c;
        font-size: 14px;
    }

    .schedul-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .schedul-box-item {
            width: 60px;
            height: 36px;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #05f;
            font-size: 12px;
            background: rgba(0, 85, 255, .08);
            margin-right: 8px;
            line-height: 14px;
            position: relative;
            cursor: pointer;

            .schedul-select {
                width: 10px;
                height: 10px;
                position: absolute;
                top: 0;
                right: 0;
                background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/common/schadul-select.png") no-repeat;
                background-size: 100% 100%;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    width: 6px;
                    height: 4px;
                }
            }

            .schedul-box-item-notacross {
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                flex-direction: column;
            }

            .schedul-box-item-across {
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
            }

            .schedul-box-item-time {
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
            }
        }

        .schedul-box-item-not {
            color: rgba(197, 214, 247, 1);
            background: rgba(241, 245, 255, 1);
        }

        .schedul-box-item:last-child {
            margin-right: 0;
        }
    }

    .area-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;

        .area-box-item {
            padding: 3px 10px;
            border-radius: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #3b6fff;
            font-size: 14px;
            background: rgba(59, 111, 255, .1);
            flex-direction: column;
            margin: 6px 6px 6px 0;
            line-height: 1;
        }

        .area-box-item-not {
            color: #999;
            background: #f4f6f9;
        }

        .area-box-item:last-child {
            margin-right: 0;
        }
    }

    .veui-button {
        height: 40px;
        width: 80px;
        font-size: 16px;
        border-radius: 5px;
    }

    .pagination {
        float: right;
        padding-top: 30px;
    }

    .pagination-bot {
        overflow: hidden;
    }

    .line {
        clear: both;
        margin-bottom: 24px;
    }

    .transfer-once-lawyer {
        position: absolute;
        height: 48px;
        right: 0;
        top: 0;
        cursor: pointer;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #05f;
        line-height: 48px;
        font-weight: 400;
        display: flex;
        z-index 22
        align-items: center;
        margin-top: -15px;

        .export-icon {
            margin-right: 4px;
            width: 20px;
            height: 20px;
            background: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/offline-qa/export.png) no-repeat center center / 100% 100%;
        }
    }

    .tooltip-icon {
        vertical-align: middle;
    }
}
</style>
